import _ from 'underscore';
import React from 'react';

import Layout from 'components/Layout';
import SectionLayout from 'components/SectionLayout';

import ViewsSenderContainer from 'containers/ViewsSender';

import CommonPropTypes from 'utils/propTypes/common';

import MainSection from './components/MainSection';
import NearestBroadcasts from './components/NearestBroadcasts';
import PassedBroadcasts from './components/PassedBroadcasts';
import PopularBroadcasts from './components/PopularBroadcasts';
import PopularInstitutes from './components/PopularInstitutes';

const Template = ({
	institute,
	nearestBroadcasts,
	passedBroadcasts,
	popularBroadcasts,
	popularInstitutes,
	breadcrumbs,
	entityMeta
}) => {
	const hasPopularBroadcasts = !_(popularBroadcasts).isEmpty();
	const hasPopularInstitutes = !_(popularInstitutes).isEmpty();
	const hasSectionMore = hasPopularBroadcasts || hasPopularInstitutes;

	return (
		<Layout
			meta={entityMeta}
			entity={institute}
			entityType="streamingPlatforms"
			rubricPath="live/streaming-platforms"
			noCover
		>
			<SectionLayout gutter="bottom">
				<MainSection data={institute} breadcrumbs={breadcrumbs} />
				{!_.isEmpty(nearestBroadcasts) && (
					<NearestBroadcasts data={nearestBroadcasts} />
				)}
				{!_.isEmpty(passedBroadcasts) && (
					<PassedBroadcasts data={passedBroadcasts} institute={institute} />
				)}
			</SectionLayout>
			{hasSectionMore && (
				<SectionLayout theme="light" gutter="full">
					{hasPopularBroadcasts && (
						<PopularBroadcasts data={popularBroadcasts} />
					)}
					{hasPopularInstitutes && (
						<PopularInstitutes data={popularInstitutes} />
					)}
				</SectionLayout>
			)}

			<ViewsSenderContainer entityType="institutes" entityId={institute._id} />
		</Layout>
	);
};

Template.propTypes = {
	institute: CommonPropTypes.entity.isRequired,
	nearestBroadcasts: CommonPropTypes.entities,
	passedBroadcasts: CommonPropTypes.entities,
	popularBroadcasts: CommonPropTypes.entities,
	popularInstitutes: CommonPropTypes.entities,
	breadcrumbs: CommonPropTypes.breadcrumbs.isRequired,
	entityMeta: CommonPropTypes.meta.isRequired
};

export default Template;
